import React, { useState, useEffect } from "react";
import "./Slider.css";

const images = [
  "/images/ZeeResizer.png",
  "/images/carousel1.jpg"
 
];

const Slider = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="slider">
      {images.map((img, i) => (
        <div
          key={i}
          className={`slide ${i === current ? "active" : ""}`}
          style={{ backgroundImage: `url(${img})` }}
        ></div>
      ))}
      <div className="overlay">
        <h1 className="slider-title">Welcome to Prof. (Dr) Mallick’s World</h1>
        <p className="slider-subtitle">Innovation • Inclusion • Impact</p>
      </div>
    </div>
  );
};

export default Slider;
